import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { SharedModule } from '../../../shared/shared.module';
import { GridModule } from '@progress/kendo-angular-grid';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { SendToIntacctComponent } from './send-to-intacct.component';

@NgModule({
  declarations: [
    SendToIntacctComponent
  ],
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule,
    GridModule, DateInputsModule,
    // SharedModule
  ],
  exports: [SendToIntacctComponent],
  providers: [],
})
export class SendToIntacctModule { }
